import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"
import List from "../../List/List"

class OrderFormPresenterFormFields extends React.Component {

  constructor(props) {
    super(props)  
  }

  render() {
    // console.log("form_fields_present", this.props)
    var tabClasses = clsx({
      'active': this.props.active_tab == 'form_fields',
      'tab-pane': true
    })

    return (
      <div className={tabClasses} id="form_fields">
        { this.props.form_fields.length
          ? <List 
              header_primary="form_fields"
              items={this.props.form_fields}
              display_column_primary="field" 
              display_column_secondary="field_type" />
          : <div className="no-records">
              <span className="none">{I18n.t('none')}</span>
            </div>
        }
      </div>
    )
  }
}

export default OrderFormPresenterFormFields